import { render } from "./RadialChart.vue?vue&type=template&id=b4610fac&scoped=true"
import script from "./RadialChart.vue?vue&type=script&lang=js"
export * from "./RadialChart.vue?vue&type=script&lang=js"

import "./RadialChart.vue?vue&type=style&index=0&id=b4610fac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4610fac"]])

export default __exports__